import { Component, OnInit, Inject, HostListener } from '@angular/core';
import { FormBuilder, FormGroup, FormControl, Validators } from '@angular/forms';
import { DOCUMENT } from '@angular/common';
import { Observable } from  "rxjs";
import { debounceTime } from 'rxjs/operators';
import { HttpClient, HttpHeaders } from '@angular/common/http';
import { ITrialService } from '../../services/Trial/trial.service.interface';
import { Router } from '@angular/router';
import { TrialRegistration } from '../../models/trialRegistration';
import { AuthenticationService } from '../../services/auth.service';


@Component({
  selector: 'app-trial-form',
  templateUrl: './trial-form.component.html',
  styleUrls: ['./trial-form.component.scss']
})
export class TrialFormComponent implements OnInit {

  trialForm: FormGroup;
  document: Document;
  scrollPosition: number;
  fixHeaderAt: number;
  trialService: ITrialService;
  loginPrefix: string;
  isNewCustomer: boolean = false;
 

  shouldShowSpinner : boolean;

  constructor(private authService: AuthenticationService, private http: HttpClient, trialService: ITrialService, formBuilder: FormBuilder, @Inject(DOCUMENT) document: Document, private router: Router) { 
    this.trialService = trialService;
    this.scrollPosition = 0;
    this.document = document;
    this.fixHeaderAt = 240;

    this.trialForm = formBuilder.group({
      terms: new FormControl('', Validators.requiredTrue)
    });
  }

  onSubformReady(name: string, form: FormGroup) {
    this.trialForm.addControl(name, form);
    if (name == 'org') {
      (this.trialForm.get('org') as FormGroup).controls['orgName'].valueChanges.pipe(debounceTime(500)).subscribe((val) => {
        this.onOrgNameEntered(val);
      });
    }
  }

  onOrgNameEntered(val: string) {
    this.trialService.getPrefixSuggestion(val).subscribe(suggestion => {
      this.loginPrefix = suggestion.prefix;
    })
  }

  login() {

    this.authService.startAuthentication().then(function () {
    }).catch(function (err) {
      console.log(err);
    });
  }

  newCustomer() {
    this.isNewCustomer = true;
  }

  onSubmit() {
    this.trialForm.markAsTouched();

    if (this.trialForm.valid) {
      
      let contact = this.trialForm.value.contact;
      let address = this.trialForm.value.org.address;
      let org = this.trialForm.value.org;

      let newTrial = new TrialRegistration();
      newTrial.acceptsTerms = this.trialForm.value.terms;
      newTrial.city = address.city;
      newTrial.countryCode = address.country;
      newTrial.email = contact.email;
      newTrial.firstName = contact.firstName;
      newTrial.lastName = contact.lastName;
      newTrial.organizationName = org.orgName;
      newTrial.phone = contact.ext == "" ? contact.phone : contact.phone + " ext. " + contact.ext;
      newTrial.postalCode = address.zip;
      newTrial.stateCode = address.state;
      newTrial.street1 = address.street;
      newTrial.street2 = address.suite;
      newTrial.loginPrefix = this.loginPrefix;
      //newTrial.industry = org.industry;

      localStorage.setItem("trialModel", JSON.stringify(newTrial));     
            
      this.shouldShowSpinner = true;
      this.router.navigate(["/createAccount"]);

    } else {    
      this.markAllTouched(this.trialForm);
    }

  }

  markAllTouched(group: FormGroup) {
    var controls = Object.keys(group.controls);
    for(var i = 0; i < controls.length; i++) {
      var currentControl = group.controls[controls[i]];
      if(currentControl instanceof FormGroup) {
        this.markAllTouched(currentControl);
      } else {
        currentControl.markAsTouched();
      }
    }
  }

  ngOnInit() {
    this.fixHeaderAt = document.documentElement.clientWidth < 660 ? 360 : 240;
    this.scrollPosition = this.document.documentElement.scrollTop;
    localStorage.clear();
  }

  @HostListener("window:scroll", [])
  onWindowScroll() {
    this.scrollPosition = this.document.documentElement.scrollTop;
  }

  @HostListener("window:resize", [])
  onWindowResize() {
    this.fixHeaderAt = document.documentElement.clientWidth < 660 ? 360 : 240;
  }

}
